/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";

import { Modal, Card, Table, message, Form, Button } from "antd";
import { Row, Col, Space, Spin, Flex, Checkbox } from "antd";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useForm } from "antd/es/form/Form";

import { columns } from "./model";
import OptionService from "../../../../service/ERP/Options.service";
import { BsUiChecks } from "react-icons/bs";
import { TagItemTypes } from "../../../badge-and-tag/ERP";

const CheckboxGroup = Checkbox.Group;

const options = [  
  // { value: "Finish Goods", label: "Finish Goods" },
  // { value: "Raw Material", label: "Raw Material" },
  // { value: "Ingredients", label: "Ingredients" },
  { value: "Packing", label: "Packing" },
  { value: "Packaging", label: "Packaging" },
];

export default function ModalPKmatbom({ show, close, values,selected}) {
  const optionService = OptionService();
  const [form] = useForm();
  const inputRef = useRef(null);
  const [modalData, setModalData] = useState([]);
  const [modalDataWrap, setModalDataWrap] = useState([]);

  const [openModal, setOpenModel] = useState(show);
  const [loading, setLoading] = useState(true);
  const [onLoaded, setOnLoaded] = useState(false);

  const [itemsList, setItemsList] = useState(selected || []);
  const [itemsRowKeySelect, setItemsRowKeySelect] = useState([]);

  // const [rowKeySelect, setRowKeySelect] = useState([]);
  const [checkedList, setCheckedList] = useState(options.map((option) => option.value)); // Default check all options
  const [itemsTypeOption, setItemTypeOption] = useState([]);

  const checkAll = itemsTypeOption.length === checkedList.length; // ตรวจสอบว่าเลือกทั้งหมดหรือไม่
  const indeterminate =
    checkedList.length > 0 && checkedList.length < itemsTypeOption.length;

  const onChange = (list) => {
    setCheckedList([...list]);
  };

  const onCheckAllChange = (e) => {
    const all = e.target.checked ? itemsTypeOption.map((m) => m.value) : [];
    setCheckedList([...all]);
  };

  /** handle logic component */
  const handleClose = () => {
    setTimeout(() => {
      close(false);
    }, 140);

    //setTimeout( () => close(false), 200 );
  };

  const handleSearch = (value) => {
    const types = [...checkedList];

    if (!!value) {
      const f = modalData.filter((d) => {
        const text =
          d.pk_code?.toLowerCase().includes(value?.toLowerCase()) ||
          d.pk_name?.toLowerCase().includes(value?.toLowerCase());
        const type = types.includes(d.typename);
        return text && type;
      });
      setModalDataWrap(f);
    } else {
      const f = modalData.filter((d) => {
        const type = types.includes(d.typename);
        return type;
      });
      setModalDataWrap(f);
    }
  };

  const handleSelectItems = (record) => {
    const newData = {
      ...record,
      qty: 1,
      percent: 0,
      totalpercent: 0,
    };
    // console.log(newData);

    setItemsList([...itemsList, newData]);
  };

  const handleCheckDuplicate = (itemCode) =>
    !!selected.find((item) => item?.pk_code === itemCode);

  const handleConfirm = () => {
    // console.log(selected);
    const choosed = selected.map((m) => m.pk_code);
    const itemsChoose = modalData
      .filter(
        (f) =>
          itemsRowKeySelect.includes(f.pk_code) && !choosed.includes(f.pk_code)
      )
      .map((m, i) => ({
        seq: i + 1,
        pk_code: m.pk_code,
        pk_name: m.pk_name,
        typename: m.typename,
        qty: 1,
      }));

    // console.log(itemsChoose, choosed);

    values([...selected, ...itemsChoose]);

    setItemsList([]);
    close(false);
  };

  /** setting initial component */
  const column = columns({ handleSelectItems, handleCheckDuplicate });

  useEffect(() => {
    if (onLoaded) {
      setLoading(true);
      setTimeout(() => {
        const value = inputRef.current?.input.value;
        handleSearch(value);

        setLoading(false);
      }, 200);
    }
  }, [checkedList]);

  useEffect(() => {
    const onload = () => {
      setLoading(true);
      // alert(cuscode)
      optionService
        .optionsPKMaterial({})
        .then(async (res) => {
          let { data } = res.data;
          setModalData(data);
          setModalDataWrap(data);
          // console.log(modalData, data)
          // const keySelected = selected.map((m) => m.code);
          const allOptions = options.map((m) => ({
            label: <TagItemTypes data={m.value} />,
            value: m.value,
          }));
          setItemTypeOption(allOptions);
          setCheckedList([...allOptions.map(m=>m.value)]);                

        })
        .catch((err) => {
          message.error("Request error!");

          // setLoading(false);
        })
        .finally(() =>
          setTimeout(() => {
            setLoading(false);
            setOnLoaded(true);
          }, 400)
        );
    };
    if (!!openModal) {
      onload();

      // console.log("modal-packages")
    }
  }, [openModal]);

   /** Config Conponent */

  const itemSelection = {
    selectedRowKeys: itemsRowKeySelect,
    type: "checkbox",
    fixed: true,
    // hideSelectAll: false,

    onChange: (selectedRowKeys, selectedRows) => {
      setItemsRowKeySelect([
        ...new Set([...selectedRowKeys, ...itemsRowKeySelect]),
      ]);
      setItemsList(selectedRows);
      setItemsRowKeySelect(selectedRowKeys);
    },
    getCheckboxProps: (record) => {
      return {
        disabled: handleCheckDuplicate(record.pk_code),
        name: record.pk_code,
      };
    },
    onSelect: (record, selected, selectedRows, nativeEvent) => {
      //console.log(record, selected, selectedRows, nativeEvent);
      if (selected) {
        setItemsRowKeySelect([
          ...new Set([...itemsRowKeySelect, record.pk_code]),
        ]);
      } else {
        const ind = itemsRowKeySelect.findIndex((d) => d === record.pk_code);
        const tval = [...itemsRowKeySelect];
        tval.splice(ind, 1);
        setItemsRowKeySelect([...tval]);
        // console.log(ind, itemsRowKeySelect);
      }
    },
  };
  /** setting child component */
    const ButtonModal = (
      <Space direction="horizontal" size="middle">
        <Button onClick={() => handleClose()}>ปิด</Button>
        <Button type="primary" onClick={() => handleConfirm()}>
          ยืนยันการเลือกสินค้า
        </Button>
      </Space>
    );

  return (
    <>
      <Modal
        open={openModal}
        title="เลือกสินค้า"
        afterClose={() => handleClose()}
        onCancel={() => setOpenModel(false)}
        footer={ButtonModal}
        maskClosable={false}
        style={{ top: 20 }}
        width={1200}
        className="modal-material"
      >
        <Spin spinning={loading}>
          <Space
            direction="vertical"
            size="middle"
            style={{ display: "flex", position: "relative" }}
          >
            <Card style={{ backgroundColor: "#f0f0f0" }}>
              <Form form={form} layout="vertical" autoComplete="off">
                <Row
                  gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
                  className="m-0"
                >
                  <Col span={24}>
                    <Form.Item label="ค้นหา">
                      <Input
                        ref={inputRef}
                        suffix={<SearchOutlined />}
                        onChange={(e) => {
                          handleSearch(e.target.value);
                        }}
                        placeholder="ค้นหาชื่อ หรือ รหัส"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row
                  gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
                  className="m-0"
                >
                  <Col span={24}>
                    <Checkbox
                      indeterminate={indeterminate}
                      onChange={onCheckAllChange}
                      checked={checkAll}
                    >
                      <TagItemTypes data={"Check All"} />
                    </Checkbox>
                    <CheckboxGroup
                      options={itemsTypeOption}
                      value={checkedList}
                      onChange={onChange}
                    />
                  </Col>
                </Row>
              </Form>
            </Card>
            <Card style={{ minHeight: "60vh" }}>
              <Table
                bordered
                dataSource={modalDataWrap}
                columns={column}
                rowSelection={itemSelection}
                rowKey="pk_code"
                pagination={{
                  total: modalDataWrap?.length || 0,
                  showTotal: (_, range) =>
                    `${range[0]}-${range[1]} of ${
                      modalDataWrap?.length || 0
                    } items`,
                  defaultPageSize: 10,
                  pageSizeOptions: [10,25, 35, 50, 100],
                }}
                size="small"
              />
            </Card>
          </Space>
        </Spin>
      </Modal>
    </>
  );
}
